export const environment = {
    appName: "ANGULAR_BASE_CODE",
    production: false,
    // apiUrl: 'http://172.20.10.53:47471/',
    apiUrl: 'https://devapi-timetracker.manipal.edu/', // dev
    apiPrefix: 'api/v1',
    media_domain: 'https://d2dkf813gb84zq.cloudfront.net/development' // dev
}